import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const LeftSection = styled.div`
  display: flex;
  width: 300px;
`;

export const Icon = styled.img`
  height: 100%;
  width: 24px;
  cursor: pointer;
`;

export const Heading = styled.h4`
  font-family: "SangBleu Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #05162a;
  margin-left: 20px;
`;
